import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component } from "@angular/core";

import { FilterBar } from "../../common/filter-bar/filter-bar";

@Component({
  selector: "filter-by-status",
  templateUrl: "filter-by-status.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FilterBar, TranslatePipe],
})
export class FilterByStatus {}
